export default __webpack_public_path__ + "static/media/crest5.0e3b847c.png";